import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

// tiny picker: choose one of a property's assigned utsavs.
// data = { title, utsavs: [{utsavId, name}] }; closes with the picked utsavId.
@Component({
  selector: 'app-select-utsav-dialog',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatSelectModule],
  templateUrl: './select-utsav-dialog.component.html',
  styleUrls: ['./select-utsav-dialog.component.scss', '../../../../common-style/ac-dialog.scss'],
})
export class SelectUtsavDialogComponent {
  utsavId = new FormControl<number | null>(null);

  constructor(
    private dialogRef: MatDialogRef<SelectUtsavDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { title: string; utsavs: any[] }
  ) {}

  submit(): void {
    if (!this.utsavId.value) return;
    this.dialogRef.close(Number(this.utsavId.value));
  }

  close(): void {
    this.dialogRef.close();
  }
}
